import { Route } from "react-router";
import { all_routes } from "./all_routes";
import BlankPage from "../pages/blankPage";
import Calendar from "../mainMenu/apps/calendar";
import DataTable from "../tables/dataTable";
import BasicTable from "../tables/basicTable";
import DeleteRequest from "../userManagement/deleteRequest";
import ComingSoon from "../pages/comingSoon";
import Login from "../auth/login/login";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Accordion from "../uiInterface/base-ui/accordion";
import Avatar from "../uiInterface/base-ui/avatar";
import Borders from "../uiInterface/base-ui/borders";
import Breadcrumb from "../uiInterface/base-ui/breadcrumb";
import Buttons from "../uiInterface/base-ui/buttons";
import ButtonsGroup from "../uiInterface/base-ui/buttonsgroup";
import Cards from "../uiInterface/base-ui/cards";
import Carousel from "../uiInterface/base-ui/carousel";
import Colors from "../uiInterface/base-ui/colors";
import Dropdowns from "../uiInterface/base-ui/dropdowns";
import Grid from "../uiInterface/base-ui/grid";
import Images from "../uiInterface/base-ui/images";
import Lightboxes from "../uiInterface/base-ui/lightbox";
import Media from "../uiInterface/base-ui/media";
import Modals from "../uiInterface/base-ui/modals";
import NavTabs from "../uiInterface/base-ui/navtabs";
import Offcanvas from "../uiInterface/base-ui/offcanvas";
import Pagination from "../uiInterface/base-ui/pagination";
import Popovers from "../uiInterface/base-ui/popover";
import RangeSlides from "../uiInterface/base-ui/rangeslider";
import Progress from "../uiInterface/base-ui/progress";
import Spinner from "../uiInterface/base-ui/spinner";
import Toasts from "../uiInterface/base-ui/toasts";
import Typography from "../uiInterface/base-ui/typography";
import Video from "../uiInterface/base-ui/video";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";
import ClipBoard from "../uiInterface/advanced-ui/clipboard";
import Counter from "../uiInterface/advanced-ui/counter";
import DragAndDrop from "../uiInterface/advanced-ui/dragdrop";
import Rating from "../uiInterface/advanced-ui/rating";
import Stickynote from "../uiInterface/advanced-ui/stickynote";
import TextEditor from "../uiInterface/advanced-ui/texteditor";
import Timeline from "../uiInterface/advanced-ui/timeline";
import Scrollbar from "../uiInterface/advanced-ui/uiscrollbar";
import Apexchart from "../uiInterface/charts/apexcharts";
import FeatherIcons from "../uiInterface/icons/feathericon";
import FontawesomeIcons from "../uiInterface/icons/fontawesome";
import MaterialIcons from "../uiInterface/icons/materialicon";
import PE7Icons from "../uiInterface/icons/pe7icons";
import SimplelineIcons from "../uiInterface/icons/simplelineicon";
import ThemifyIcons from "../uiInterface/icons/themify";
import TypiconIcons from "../uiInterface/icons/typicons";
import WeatherIcons from "../uiInterface/icons/weathericons";
import BasicInputs from "../uiInterface/forms/formelements/basic-inputs";
import CheckboxRadios from "../uiInterface/forms/formelements/checkbox-radios";
import InputGroup from "../uiInterface/forms/formelements/input-group";
import GridGutters from "../uiInterface/forms/formelements/grid-gutters";
import FormSelect from "../uiInterface/forms/formelements/form-select";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import FileUpload from "../uiInterface/forms/formelements/fileupload";
import FormHorizontal from "../uiInterface/forms/formelements/layouts/form-horizontal";
import FormVertical from "../uiInterface/forms/formelements/layouts/form-vertical";
import FloatingLabel from "../uiInterface/forms/formelements/layouts/floating-label";
import FormValidation from "../uiInterface/forms/formelements/layouts/form-validation";
import FormSelect2 from "../uiInterface/forms/formelements/layouts/form-select2";
import FormWizard from "../uiInterface/forms/formelements/form-wizard";
import DataTables from "../uiInterface/table/data-tables";
import TablesBasic from "../uiInterface/table/tables-basic";
import IonicIcons from "../uiInterface/icons/ionicicons";
import Badges from "../uiInterface/base-ui/badges";
import Placeholder from "../uiInterface/base-ui/placeholder";
import Alert from "../uiInterface/base-ui/alert";
import Tooltips from "../uiInterface/base-ui/tooltips";
import Ribbon from "../uiInterface/advanced-ui/ribbon";
import AdminDashboard from "../mainMenu/dashboard";
import AlertUi from "../uiInterface/base-ui/alert-ui";
import StudentGrid from "../peoples/students/student-grid";
import AddStudent from "../peoples/students/add-student";
import StudentList from "../peoples/students/student-list";
import StudentDetails from "../peoples/students/student-details/studentDetails";
import StudentAttendanceDetail from "../peoples/students/student-details/studentAttendanceDetail";
import StudentFees from "../peoples/students/student-details/fee-details/studentFees";
import StudentFeesDiscount from "../peoples/students/student-details/fee-details/components/studentFeesDiscount";
import StudentResult from "../peoples/students/student-details/studentResult";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import StudentAttendance from "../hrm/attendance/student-attendance";
import RolesPermissions from "../userManagement/rolesPermissions";
import Permission from "../userManagement/permission";
import Manageusers from "../userManagement/manageusers";
import Profile from "../pages/profile";
import LockScreen from "../auth/lockscreen/lockScreen";
import EmailVerification from "../auth/emailVerification/emailVerification";
import NotificationActivities from "../pages/profile/activities";
import CenterList from "../peoples/centers/center-list";
import CenterDetails from "../peoples/centers/center-details/centerDetails";
import AddCenter from "../peoples/centers/add-center";
import CenterGrid from "../peoples/centers/center-grid";
import SessionList from "../configuration/session/session-list";
import AddSession from "../configuration/session/add-session";
import AssignMarks from "../assessment/marks/assign-marks";
import CollectFees from "../feescollection/pages/CollectFees";
import FeesConfiguration from "../feeconfig/courseFeeConfig/pages/FeesConfiguration";
import AddFeeConfig from "../feeconfig/courseFeeConfig/components/AddFeeConfig";
import AddFeeType from "../feetypes/components/AddFeeType";
import FeeTypes from "../feetypes/pages/FeeTypes";
import AddCourse from "../configuration/course/add-course";
import CourseList from "../configuration/course/course-list";
import BatchTimingList from "../configuration/batch-timing/batch-timing-list/BatchTimingList";
import AddBatchTiming from "../configuration/batch-timing/add-batch-timing/AddBatchTiming";
import GenerateStudentID from "../peoples/students/generate-id";
import SettingList from "../settings/setting-list";
import AddSetting from "../settings/add-setting";
import Error401 from "../pages/error/error-401";
import StudentPromotion from "../promotion/student-promotion";
import Users from "../peoples/centers/users/users";
import AddUser from "../peoples/centers/users/add-user/index";
import NotificationList from "../notifications/notification-list";
import NotificationDetail from "../notifications/notification-detail";
import AddNotification from "../notifications/add-notification";
import AddCenterAdminNotification from "../notifications/add-notification/center-admin";
import StudentDocuments from "../peoples/students/student-documents";
import NotificationView from "../notifications/notification-view";
import ImportStudents from "../peoples/students/import-students";
import StudentFeesInvoice from "../peoples/students/student-details/fee-details/components/studentFeesInvoice";
import GenerateInvoices from "../feescollection/components/GenerateInvoices";
// import EditNotification from "../notifications/edit-notification";
import RegistrationFeeConfiguration from "../feeconfig/registrationFeeConfig/pages/RegistrationFeesConfiguration";
import AddRegistrationFeeConfig from "../feeconfig/registrationFeeConfig/components/AddRegistrationFeeConfig";
import PaymentDetails from "../peoples/students/student-details/fee-details/components/paymentDetails";
import AddCourseFeeShare from "../fee-share/courseFeeShare/add-course-fee-share";
import CourseFeeShareList from "../fee-share/courseFeeShare/list";
import AddRegistrationFeeShare from "../fee-share/registrationFeeShare/add-registration-fee-share";
import RegistrationFeeShareList from "../fee-share/registrationFeeShare/list";
import ViewCourseFeeShare from "../fee-share/courseFeeShare/view-course-fee-share";
import ViewRegistrationFeeShare from "../fee-share/registrationFeeShare/view-registration-fee-share";
import Billing from "../peoples/students/billing";
// Book Request Module
import BookRequestList from "../books/bookRequest/request-list";
import CreateBookRequest from "../books/bookRequest/create-request";
import ViewBookRequest from "../books/bookRequest/request-list/view-request";
import CenterFeeDetails from "../peoples/centers/center-details/centerFeeDetails";
import CenterCourseFeeShare from "../peoples/centers/center-details/centerCourseFeeShare";
import CenterRegFeeShare from "../peoples/centers/center-details/centerRegFeeShare";
import PayShareList from "../pay-share/list";
import PayShareDetails from "../pay-share/details";
import CenterProfile from "../peoples/centers/center-profile";

const routes = all_routes;

export const publicRoutes = [
  // {
  //   path: "/",
  //   name: "Root",
  //   element: <Navigate to="/login" />,
  //   route: Route,
  // },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  // Notification routes
  {
    path: routes.notificationList,
    element: <NotificationList />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.notificationDetail,
    element: <NotificationDetail />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.addNotification,
    element: <AddNotification />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addCenterAdminNotification,
    element: <AddCenterAdminNotification />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.editCenterAdminNotification,
    element: <AddCenterAdminNotification />,
    allowedRoles: ["centeradmin"],
    route: Route,
  },
  {
    path: routes.notificationView,
    element: <NotificationView />,
    allowedRoles: ["centeradmin"],
    route: Route,
  },
  {
    path: routes.editNotification,
    element: <AddNotification />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.batchTimingList,
    element: <BatchTimingList />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.addBatchTiming,
    element: <AddBatchTiming />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.editBatchTiming,
    element: <AddBatchTiming />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  // Book Request Routes
  {
    path: routes.bookRequestList,
    element: <BookRequestList />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.addBookRequest,
    element: <CreateBookRequest />,
    allowedRoles: ["centeradmin"],
    route: Route,
  },
  {
    path: routes.viewBookRequest,
    element: <ViewBookRequest />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.feesConfiguration,
    element: <FeesConfiguration />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addFeeConfiguration,
    element: <AddFeeConfig />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editFeeConfiguration,
    element: <AddFeeConfig />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.courseRegistrationFee,
    element: <RegistrationFeeConfiguration />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addCourseRegistrationFee,
    element: <AddRegistrationFeeConfig />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editCourseRegistrationFee,
    element: <AddRegistrationFeeConfig />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addFeeType,
    element: <AddFeeType />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.paymentFeeDetails,
    element: <PaymentDetails />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.addUser,
    element: <AddUser />,
    route: Route,
  },
  {
    path: routes.editUser,
    element: <AddUser />,
    route: Route,
  },
  {
    path: routes.editFeeType,
    element: <AddFeeType />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.feeTypes,
    element: <FeeTypes />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.blankPage,
    element: <BlankPage />,
    route: Route,
  },
  {
    path: routes.calendar,
    element: <Calendar />,
    route: Route,
  },
  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
  },

  {
    path: routes.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
  },
  {
    path: routes.accordion,
    element: <Accordion />,
    route: Route,
  },
  {
    path: routes.avatar,
    element: <Avatar />,
    route: Route,
  },
  {
    path: routes.badges,
    element: <Badges />,
    route: Route,
  },
  {
    path: routes.border,
    element: <Borders />,
    route: Route,
  },
  {
    path: routes.breadcrums,
    element: <Breadcrumb />,
    route: Route,
  },
  {
    path: routes.button,
    element: <Buttons />,
    route: Route,
  },
  {
    path: routes.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
  },
  {
    path: routes.cards,
    element: <Cards />,
    route: Route,
  },
  {
    path: routes.carousel,
    element: <Carousel />,
    route: Route,
  },
  {
    path: routes.colors,
    element: <Colors />,
    route: Route,
  },
  {
    path: routes.dropdowns,
    element: <Dropdowns />,
    route: Route,
  },
  {
    path: routes.grid,
    element: <Grid />,
    route: Route,
  },
  {
    path: routes.images,
    element: <Images />,
    route: Route,
  },
  {
    path: routes.lightbox,
    element: <Lightboxes />,
    route: Route,
  },
  {
    path: routes.media,
    element: <Media />,
    route: Route,
  },
  {
    path: routes.modals,
    element: <Modals />,
    route: Route,
  },
  {
    path: routes.navTabs,
    element: <NavTabs />,
    route: Route,
  },
  {
    path: routes.offcanvas,
    element: <Offcanvas />,
    route: Route,
  },
  {
    path: routes.pagination,
    element: <Pagination />,
    route: Route,
  },
  {
    path: routes.popover,
    element: <Popovers />,
    route: Route,
  },
  {
    path: routes.rangeSlider,
    element: <RangeSlides />,
    route: Route,
  },
  {
    path: routes.progress,
    element: <Progress />,
    route: Route,
  },
  {
    path: routes.studentPromotion,
    element: <StudentPromotion />,
    route: Route,
  },
  {
    path: routes.spinner,
    element: <Spinner />,
    route: Route,
  },

  {
    path: routes.typography,
    element: <Typography />,
    route: Route,
  },
  {
    path: routes.video,
    element: <Video />,
    route: Route,
  },
  {
    path: routes.toasts,
    element: <Toasts />,
    route: Route,
  },
  {
    path: routes.clipboard,
    element: <ClipBoard />,
    route: Route,
  },
  {
    path: routes.counter,
    element: <Counter />,
    route: Route,
  },
  {
    path: routes.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
  },
  {
    path: routes.rating,
    element: <Rating />,
    route: Route,
  },
  {
    path: routes.stickyNotes,
    element: <Stickynote />,
    route: Route,
  },
  {
    path: routes.textEditor,
    element: <TextEditor />,
    route: Route,
  },
  {
    path: routes.timeLine,
    element: <Timeline />,
    route: Route,
  },
  {
    path: routes.scrollBar,
    element: <Scrollbar />,
    route: Route,
  },
  {
    path: routes.apexChat,
    element: <Apexchart />,
    route: Route,
  },
  {
    path: routes.featherIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.falgIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.materialIcon,
    element: <MaterialIcons />,
    route: Route,
  },
  {
    path: routes.pe7icon,
    element: <PE7Icons />,
    route: Route,
  },
  {
    path: routes.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    path: routes.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    path: routes.typicon,
    element: <TypiconIcons />,
    route: Route,
  },
  {
    path: routes.basicInput,
    element: <BasicInputs />,
    route: Route,
  },
  {
    path: routes.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
  },
  {
    path: routes.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
  },
  {
    path: routes.inputGroup,
    element: <InputGroup />,
    route: Route,
  },
  {
    path: routes.gridandGutters,
    element: <GridGutters />,
    route: Route,
  },
  {
    path: routes.formSelect,
    element: <FormSelect />,
    route: Route,
  },
  {
    path: routes.formMask,
    element: <FormMask />,
    route: Route,
  },
  {
    path: routes.fileUpload,
    element: <FileUpload />,
    route: Route,
  },
  {
    path: routes.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
  },
  {
    path: routes.verticalForm,
    element: <FormVertical />,
    route: Route,
  },
  {
    path: routes.floatingLable,
    element: <FloatingLabel />,
    route: Route,
  },
  {
    path: routes.formValidation,
    element: <FormValidation />,
    route: Route,
  },
  {
    path: routes.reactSelect,
    element: <FormSelect2 />,
    route: Route,
  },
  {
    path: routes.formWizard,
    element: <FormWizard />,
    route: Route,
  },
  {
    path: routes.dataTable,
    element: <DataTables />,
    route: Route,
  },
  {
    path: routes.tableBasic,
    element: <TablesBasic />,
    route: Route,
  },
  {
    path: routes.iconicIcon,
    element: <IonicIcons />,
    route: Route,
  },
  // {
  //   path: routes.chart,
  //   element: <ChartJs />,
  //   route: Route,
  // },

  {
    path: routes.placeholder,
    element: <Placeholder />,
    route: Route,
  },
  {
    path: routes.sweetalert,
    element: <Alert />,
    route: Route,
  },
  {
    path: routes.alert,
    element: <AlertUi />,
    route: Route,
  },
  {
    path: routes.tooltip,
    element: <Tooltips />,
    route: Route,
  },
  {
    path: routes.ribbon,
    element: <Ribbon />,
    route: Route,
  },

  // Peoples Module
  {
    path: routes.centerGrid,
    element: <CenterGrid />,
    allowedRoles: ["superadmin"],
  },
  {
    path: routes.centerList,
    element: <CenterList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addCenter,
    element: <AddCenter />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.centerDetails,
    element: <CenterDetails />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.centerFeeDetails,
    element: <CenterFeeDetails />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editCenter,
    element: <AddCenter />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.studentGrid,
    element: <StudentGrid />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.studentList,
    element: <StudentList />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.importStudents,
    element: <ImportStudents />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentDocuments,
    element: <StudentDocuments />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.addStudent,
    element: <AddStudent />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.editStudent,
    element: <AddStudent />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentDetail,
    element: <StudentDetails />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentAttendanceDetail,
    element: <StudentAttendanceDetail />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentFees,
    element: <StudentFees />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentFeesDiscount,
    element: <StudentFeesDiscount />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentFeesInvoice,
    element: <StudentFeesInvoice />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentResult,
    element: <StudentResult />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.generateInvoices,
    element: <GenerateInvoices />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.billingSection,
    element: <Billing />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.layoutDefault,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutMini,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutRtl,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutBox,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutDark,
    element: <AdminDashboard />,
  },
  {
    path: routes.generateStudentID,
    element: <GenerateStudentID />,
  },
  {
    path: routes.collectFees,
    element: <CollectFees />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.studentAttendance,
    element: <StudentAttendance />,
    allowedRoles: ["superadmin", "centeradmin"],
  },
  {
    path: routes.rolesPermissions,
    element: <RolesPermissions />,
  },
  {
    path: routes.permissions,
    element: <Permission />,
  },
  {
    path: routes.manageusers,
    element: <Manageusers />,
  },
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.activity,
    element: <NotificationActivities />,
  },
  {
    path: routes.centerDetails,
    element: <CenterDetails />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.centerDetailsId,
    element: <CenterDetails />,
    route: Route,
  },
  {
    path: routes.centerUsers,
    element: <Users />,
    route: Route,
  },
  {
    path: routes.centerUsersId,
    element: <Users />,
    route: Route,
  },
  {
    path: routes.centerProfile,
    element: <CenterProfile />,
    allowedRoles: ["centeradmin"],
    route: Route,
  },

  // Configuration
  {
    path: routes.sessionList,
    element: <SessionList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addSession,
    element: <AddSession />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editSession,
    element: <AddSession />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.courseList,
    element: <CourseList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addCourse,
    element: <AddCourse />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editCourse,
    element: <AddCourse />,
    allowedRoles: ["superadmin"],
    route: Route,
  },

  // Assessment
  {
    path: routes.assignMarks,
    element: <AssignMarks />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },

  // Settings
  {
    path: routes.settingList,
    element: <SettingList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addSetting,
    element: <AddSetting />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editSetting,
    element: <AddSetting />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addCourseFeeShare,
    element: <AddCourseFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editCourseFeeShare,
    element: <AddCourseFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.courseFeeShareList,
    element: <CourseFeeShareList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.viewCourseFeeShare,
    element: <ViewCourseFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.addRegistrationFeeShare,
    element: <AddRegistrationFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.editRegistrationFeeShare,
    element: <AddRegistrationFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.registrationFeeShareList,
    element: <RegistrationFeeShareList />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.viewRegistrationFeeShare,
    element: <ViewRegistrationFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.configureRegFeeShare,
    element: <CenterRegFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },
  {
    path: routes.configureCourseFeeShare,
    element: <CenterCourseFeeShare />,
    allowedRoles: ["superadmin"],
    route: Route,
  },

  // Pay Share routes
  {
    path: routes.payShareList,
    element: <PayShareList />,
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
  {
    path: routes.viewPayShare,
    element: <PayShareDetails />, // Updated to use the new PayShareDetails component
    allowedRoles: ["superadmin", "centeradmin"],
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.error401,
    element: <Error401 />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
    route: Route,
  },
];
